<template>
<div>
<v-card style="width: 300px;">
  <v-card-text class="greyText">

  <div class="fullWidth blueText bigTitle">
    Transactions
  </div>

  <div class="fullWidth">
    <div class="floatLeft titleText">{{savings.name}}</div>
    <div class="floatRight" style="">
      <div style="float: right" class="greenText">/{{savings.targetAmount}}</div>
      <div style="float: right;" class="blueText">{{savings.currentAmount}}</div>
    </div>
  </div>

  <v-divider></v-divider>

  <div class="fullWidth">
    <div class="floatLeft titleText">Transactions:</div>
    <div class="floatRight">{{ transactions.length - 1 }}</div>
  </div>

  <v-divider></v-divider>

  <div class="fullWidth">
    <div class="floatLeft titleText">Date Added:</div>
    <div class="floatRight">{{ savings.dateAdded}}</div>
  </div>

  <v-divider></v-divider>

  <div class="fullWidth">
    Last 6 Transactions
  </div>

  <div class="fullWidth">
    <div v-for="transaction of transactions">
      <div class="floatLeft">{{capitalize(transaction.transactionType)}} of {{transaction.transactionAmount}}</div>
      <div class="floatRight">{{transaction.transactionDate}}</div>
    </div>
  </div>
  </v-card-text>
   <v-card-actions>
     <div class="aThirdRow">
       <div class="aThird">
         <v-btn flat color="blue" @click="update">UPDATE</v-btn>
       </div>
       <div class="aThird">
         <v-btn flat color="error" @click="deleteSavings">DELETE</v-btn>
       </div>
       <div class="aThird">
         <v-btn flat color="yellow" @click="dismiss">CANCEL</v-btn>
       </div>
     </div>
   </v-card-actions>
  </v-card>
</div>
</template>

<script>
  export default {
    // We're gettings a savings object here
    props: ['savings', 'transactions'],
    methods: {
      capitalize(text) {
        if (!text) return ''
        text = text.toString()
        return text.charAt(0).toUpperCase() + text.slice(1)
      },
      dismiss() {
        this.$emit('dismiss')
      },
      update() {
        this.$emit('update')
      },
      deleteSavings() {
        this.$store.dispatch('delete',this.savings).then(() => {
          this.$emit('dismiss')
        });
      }
    }
  }
</script>

<style scoped>

  .fullWidth {
    width: 100%;
    /*background-color: red;*/
    margin-bottom: 10px;
    display: inline-block;
  }
  .bigTitle {
    font-size: 1.3em;
    font-weight: 500;
  }

  .titleText {
    font-size: 1.2em;
  }

  .answerText {
    font-size: 1em;
  }


  .greyText {
    color: #868787;
  }

  .greenText {
    color: limegreen !important;
  }

  .blueText {
    color: #0055D4 !important;
  }

  .redText {
    color: red;
  }

   .aThirdRow {
     /*display: inline-block;*/
   }

   .aThird {
     width: calc(100%/3);
     float: left;
   }

  .floatLeft {
    float: left;
    width: 50%;
  }

  .floatRightAdjustment {
    text-align: right !important;
  }

   .floatRight {
     text-align: right;
     float: right;
     width: 50%;
   }

</style>



// WEBPACK FOOTER //
// src/components/Shared/Transactions.vue